import React from "react";

interface SendIconProps {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const SendIcon: React.FC<SendIconProps> = ({ width = 18, height = 18, style }) => (
  <svg width={width} height={height} style={style} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 19V5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);

export default SendIcon;
